<template>
  <div class="signup">

    <!-- [Select language] start -->
    <!-- [Select language] end -->

    <!-- [ Wrapper content ] start -->
    <div class="wrapper">
      <SelectLanguage @getNewLinksList="getLinksList"/>
      <!-- [ Header form ] start -->
      <Header icon="user-plus"/>
      <!-- [ Header form ] end -->

      <!-- [ Title form ] start -->
      <Title :title="$t('auth_title_sign_up')"/>
      <!-- [ Title form ] end -->

      <!-- [ Profile switching ] start -->
      <el-row :gutter="20" type="flex" justify="center" class="row-padding footer__link">
        <el-col :span="24">
          <div>
            <el-radio-group v-model="currentTabComponent" size="mini" type="info">
              <el-radio-button label="Corporate">{{$t('auth_radio_corporate')}}</el-radio-button>
              <el-radio-button label="Personal">{{$t('auth_radio_personal')}}</el-radio-button>
            </el-radio-group>
          </div>
        </el-col>
      </el-row>
      <!-- [ Profile switching ] end -->

      <!-- [ Signup: Personal or Corporate form ] start -->
      <keep-alive>
        <component :is="currentTabComponent" :linksList="linksList"></component>
      </keep-alive>
      <!-- [ Signup: Personal or Corporate form ] end -->

      <!-- [ Footer form ] start -->
      <el-row :gutter="20" type="flex" justify="center" class="row-padding footer__link">
        <el-col :span="24">
          <div>
            {{$t('auth_already')}}
            <router-link to="/login">{{$t('auth_login')}}</router-link>
          </div>
        </el-col>
      </el-row>
      <!-- [ Footer form ] end -->
    </div>
    <!-- [ Wrapper content ] end -->

  </div>
</template>

<script>
import axios from 'axios'
import SelectLanguage from '@/components/SelectLanguage.vue'
import Header from '@/components/auth/Header.vue'
import Title from '@/components/auth/Title.vue'
import Personal from '@/components/auth/signup/Personal.vue'
import Corporate from '@/components/auth/signup/Corporate.vue'
  export default {
    components: {
      SelectLanguage,
      Header,
      Title,
      Personal,
      Corporate
    },
    mounted() {
      this.getLinksList()
    },
    data() {
      return {
        currentTabComponent: 'Corporate',
        linksList: null
      }
    },
    methods: {
      getLinksList() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/terms-and-conditions/list-by-lang?code=${localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'}`)
          .then(response => {
            loader.hide()
            const obj = {}
            response.data.list.forEach(element => {
              obj[element.code] = element
            });
            this.linksList = obj
          })
          .catch(error => {
            loader.hide()
          });
      }
    },
  }
</script>

<style lang="scss" scoped>
.signup {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 0 20px;

  background: linear-gradient(0deg,#29b996,#3498db);
	background-size: 400% 400%;
	animation: backgroundGradient 10s ease infinite;

  text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	-webkit-tap-highlight-color: rgba(0,0,0,0);

  @keyframes backgroundGradient {
    0% {
      background-position: 0 0;
    }

    50% {
      background-position: 0 100%;
    }

    100% {
      background-position: 0 0;
    }
  }

  .wrapper {
    box-sizing: border-box;
    max-width: 350px;
    padding: 40px 35px;
    background: #ffffff;
    position:relative;
    box-shadow: 0 0 15px rgba(0,0,0,0.5);
  }
}

.footer__link {
  line-height: 1.6;
  color: #909399;
}

.row-padding {
  padding: 10px 0;
}
</style>
